import { Component, OnDestroy, OnInit } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-applicant-flow-password-set',
  templateUrl: './applicant-flow-password-set.component.html',
  styleUrls: ['./applicant-flow-password-set.component.less']
})
export class ApplicantFlowPasswordSetComponent implements OnInit, OnDestroy {
  password: string;
  passwordConfirm: string;
  questionType: string = 'password';
  validationError: boolean = false;
  errorMessage: string[] = [];
  pwSet: Subject<string> = new Subject<string>();
  pwTest$: Subscription;

  constructor(private location: Router, private screening: ScreeningService, private auth: AuthService) {
    this.auth.titleBarText = 'Set Your Password';
    this.pwSet.pipe(debounceTime(500))
      .subscribe(mdl => {
        if (this.passwordConfirm == this.password) {
          this.screening.questions.DataModel.password = this.password;
          this.validationError = false;
        } else {
          this.validationError = true;
          this.errorMessage = [];
          this.errorMessage.push("Passwords must match.");
        }
        // console.log(`Updating UserName ${mdl}`);
      })
  }
  ngOnDestroy(): void {
    if(this.pwTest$) this.pwTest$.unsubscribe();
  }

  togglePWShow() {
    if (this.questionType == 'password') this.questionType = 'text';
    else this.questionType = 'password';
  }

  back() {
    this.screening.questions.moveBack();
  }

  continue() {
    this.validationError = false;
    this.errorMessage = [];
    this.pwTest$ = this.auth.CheckPassword(this.password).pipe(
      tap((_: any) => {
        if(!_.succeeded)
        {
          this.validationError = true;
          this.errorMessage.push("Please enter and confirm your password");
        }else{
          if(!this.validationError){
            if(this.screening.screeningType == 'user') this.location.navigateByUrl('/un-set');
            else this.location.navigateByUrl('/demographics');
          }
        }
      },
      (err: any) => {
        
          this.validationError = true;
          err.error.errors.forEach(er => {
            this.errorMessage.push(er.description);
          });
          // this.errorMessage =  err.error.message ?? 'There was an error testing your password. Please try another one and if the issue persists contact support.';
          return;
        
      }, 
      () => {

      })
    ).subscribe();
  }

  compare(ev: any) {
    this.pwSet.next(this.password);
  }

  ngOnInit() {
  }

}
